import { PUBLIC_DIRECTUS_URL } from '$env/static/public';
import { PUBLIC_CL_SUPABASE_ANON_KEY, PUBLIC_CL_SUPABASE_URL } from '$env/static/public';
import { isProd, site_origin } from '$lib/stores/globals';

import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
    PUBLIC_CL_SUPABASE_URL,
    PUBLIC_CL_SUPABASE_ANON_KEY
);

/**
 * Transforms an image by constructing a URL for Supabase's Image Transformation service.
 *
 * @param {string} source - a URL or a path to image.
 * @param {ImageTransformOptions} options
 * @returns {string} The URL of the transformed image.
 */
export const img_cdn = (source = '', options = {}) => {

    let bucket_path = source.startsWith('/') ? source.slice(1) : source;

    const {data: {publicUrl}} = supabase.storage.from('static').getPublicUrl(bucket_path, {
        transform: {
            width: options.w,
            height: options.h,
            resize: options.fit,
            quality: options.q,
        }
    });

    return publicUrl;
};

/**
 * @param {string} source - a URL or a path to image.
 * @param {ImageTransformOptions} options
 * @returns {string} The URL of the transformed image.
 */
export const img_cdn_srcset = (source = '', options = {}) => {
    // Never do this shit because you will spend hours looking for bugs in production that don't exist in dev
    // if (!isProd) return '';

    if (!options.w || !options.h) return '';

    let opts2x = { ...options};
    let opts3x = { ...options};

    if (options.w) {
        opts2x.w = options.w * 2;
        opts3x.w = options.w * 3;
    }

    if (options.h) {
        opts2x.h = options.h * 2;
        opts3x.h = options.h * 3;
    }

    let srcset = [
        `${img_cdn(source, options)} 1x`,
        `${img_cdn(source, opts2x)} 2x`,
        `${img_cdn(source, opts3x)} 3x`
    ];

    return srcset.join(', ');
}



/**
 * Transforms an image by constructing a URL for Supabase's Image Transformation service.
 *
 * @param {string} id - an image id.
 * @param {ImageTransformOptions} options
 * @returns {string} The URL of the transformed image.
 */
export const img_cdn_directus = (id = '', options = {}) => {
    const params = new URLSearchParams();
    
    if (options.w) params.set('width', options.w.toString());
    if (options.h) params.set('height', options.h.toString());
    if (options.q) params.set('quality', options.q.toString());
    if (options.fit) {
        const fitMap = {
            cover: 'cover',
            contain: 'contain',
            fill: 'outside'
        };
        params.set('fit', fitMap[options.fit] || 'cover');
    }
    
    const transformUrl = params.toString() ? `?${params.toString()}` : '';
    return `${PUBLIC_DIRECTUS_URL}/assets/${id}${transformUrl}`;
}

